import Flickity from 'flickity';
require('flickity-fade');

const kbalCarousels = document.querySelectorAll('.kbal-block--acf-kbal-carousel');

kbalCarousels.forEach((kbalCarousel) => {
	const carousel = kbalCarousel.querySelector('.main-carousel');
	const carouselControllers = kbalCarousel.querySelectorAll('.carousel-controls__item');

	// Create carousel
	const flickity = new Flickity(carousel, {
		autoPlay: false,
		pauseAutoPlayOnHover: false,
		draggable: false,
		prevNextButtons: true,
		pageDots: false,
		fade: true,
		on: {
			change: () => {
				for (let i = 0; i < carouselControllers.length; i++) {
					if (parseInt(carouselControllers[i].dataset.id) === parseInt(flickity.selectedIndex)) {
						carouselControllers[i].classList.add('active');
					} else {
						if (carouselControllers[i].classList.contains('active')) {
							carouselControllers[i].classList.remove('active');
						}
					}
				}
				flickity.stopPlayer();
				flickity.playPlayer();
			},
		},
	});

	// Controller events
	if (carouselControllers.length > 0) {
		carouselControllers.forEach((controller) => {
			controller.addEventListener('click', () => {
				flickity.select(controller.dataset.id, false, false);
			});
		});
	}

	const observer = new IntersectionObserver(
		function (entries) {
			if (entries[0].isIntersecting) {
				flickity.player.autoPlay = 6000;
				carouselControllers[0].classList.add('active');
				flickity.playPlayer();
				observer.unobserve(carousel);
			}
		},
		{ threshold: [0] }
	);

	observer.observe(carousel);
});
